<script setup lang="ts">
/**
 * Ответ на приглашение в календаре — значком у имени (DEV-2208).
 *
 * До этого ответ жил в подсказке при наведении и в общем счётчике полосы
 * «принял N, не ответили M»: кто именно принял, глазами было не собрать.
 * Значок несёт то же слово в подписи, но у каждого имени сразу.
 */
import { Check, CircleQuestionMark, Clock, X } from 'lucide-vue-next'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ status: string }>()

const { t } = useI18n()

const mark = computed(() => {
  switch (props.status) {
    case 'accepted':
      return { icon: Check, tone: 'yes', label: t('meetings.invites.accepted') }
    case 'declined':
      return { icon: X, tone: 'no', label: t('meetings.invites.declined') }
    case 'tentative':
      return { icon: CircleQuestionMark, tone: 'maybe', label: t('meetings.invites.tentative') }
    default:
      return { icon: Clock, tone: 'waiting', label: t('meetings.invites.waiting') }
  }
})
</script>

<template>
  <span class="answer" :class="`answer--${mark.tone}`" :title="mark.label" :aria-label="mark.label">
    <component :is="mark.icon" :size="11" aria-hidden="true" />
  </span>
</template>

<style scoped>
.answer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: var(--color-text-muted);
}

.answer--yes {
  color: var(--color-success-strong, var(--color-text-primary));
}

.answer--no {
  color: var(--color-danger, var(--color-text-primary));
}

.answer--maybe {
  color: var(--color-warning-strong, var(--color-text-muted));
}
</style>
